/**************************************************
 * Nombre: Propuesta_Valor_Portada_Documentacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Propuesta_Valor_Portada_Documentacion = () => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}>

            <Grid2 container size={12}>
                <Typography
                    sx={{
                        color: 'white',
                        fontSize: sCell ? 32 : 54,
                        fontWeight: 900,
                        textAlign: sCell ? 'center' : 'flex-start',
                        width: "100%",
                        lineHeight: 1.1
                    }}>
                    DOCUMENTACION Y
                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontSize: sCell ? 32 : 54,
                            fontWeight: 900,
                            textAlign: {xs: 'center', sm: 'left', md: 'left'},
                            width: "100%",
                            lineHeight: 1.1
                        }}
                    >
                        REPORTES
                    </Typography>
                </Typography>
            </Grid2>

            <Grid2 container size={12}>
                <Typography
                    sx={{
                        textAlign: sCell ? 'center' : 'flex-start',
                        fontSize: 18,
                        color: 'white',
                        pt: 2
                    }}>
                    En Sonar S.A.S ofrecemos documentos detallados que reflejan de manera clara y precisa el trabajo que
                    realizamos y el manejo de nuestros recursos financieros. Nuestro compromiso con la transparencia y
                    la responsabilidad nos impulsa a brindar información accesible, actualizada y verificada,
                    permitiendo a nuestros aliados, clientes y partes interesadas tener plena confianza en nuestra
                    gestión y en el cumplimiento de nuestros objetivos institucionales.
                </Typography>
            </Grid2>


        </Grid2>
    )

}
export default Propuesta_Valor_Portada_Documentacion;